import { TaskRecurrenceType } from 'aos-services/src/services/tasks/types/task/TaskRecurrenceType'
import { Dropdown, Input, InputField } from 'aos-ui-universal'
import React, { FC } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskFormField } from '../../TaskFormField'
import { TaskRecurrenceFormProps } from './TaskRecurrenceFormProps'

export const TaskRecurrenceHourly: FC<TaskRecurrenceHourlyProps> = ({
    value,
    onChange,
    errors,
    canEdit,
}) => {
    const { t: translate } = useTranslation()
    if (value?.type !== TaskRecurrenceType.Hourly) {
        return null
    }

    return (
        <TaskFormField
            label={translate('every', { ns: 'tasks' })}
            error={errors?.every ? translate('every.error', { ns: 'tasks' }) : undefined}
        >
            {canEdit ? (
                <Dropdown
                    value={value.every}
                    items={repeatsHourlyEvery}
                    labelRenderer={value => `${value}h`}
                    onChange={every => every && onChange({ every })}
                    hasClear={false}
                />
            ) : (
                <Input isDisabled>
                    <InputField value={String(value.every)} editable={false} />
                </Input>
            )}
        </TaskFormField>
    )
}

const repeatsHourlyEvery = [4, 6, 8, 12, 24]

interface TaskRecurrenceHourlyProps extends TaskRecurrenceFormProps {
    errors?: FieldErrors<any>
}
